"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WriteOff = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var coupon_1 = require("../../model/coupon");
var service_1 = require("../../../library/base/service");
var WriteOff = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(WriteOff, _super);
    function WriteOff() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '消费券核销';
        _this.code = '300003';
        _this.desc = '消费券核销';
        _this.requestParams = new coupon_1.WriteOffRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return WriteOff;
}(service_1.BaseService));
exports.WriteOff = WriteOff;
//# sourceMappingURL=writeOff.js.map